import React from "react";
import Content from "../Layout/Content";
import OrganizationSettings from "./OrganizationSettings/OrganizationSettings";
import OrganizationAdmins from "./OrganizationAdmins/OrganizationAdmins";
import OrganizationEmails from "./OrganizationEmails/OrganizationEmails";
import SendingDomains from "./SendingDomains/SendingDomains";
import AccordionEditors from "../Components/AccordionEditors/AccordionEditors";
import OrganizationAddress from "./OrganizationSettings/OrganizationAddress";
import WebhookSettings from "./Webhooks/WebhookSettings";
import ApiKeys from "./ApiKeys/ApiKeys";
import SequenceSendWindow from "./Sequences/SequenceSendWindow";
import DeliverabilityGuide from "./Deliverability/DeliverabilityGuide";
import PipelineSettings from "./Pipelines/PipelineSettings";
import ProductSettings from "./Products/ProductSettings";
import CustomFieldSettings from "./CustomFields/CustomFieldSettings";
import BillingSettings from "./Billing/BillingSettings";
import useOrgFeatures from "../utils/useOrgFeatures";


export default function () {
    // Pipelines are the stages workflows move contacts through, so they're
    // only shown when workflows are on.
    const { workflows } = useOrgFeatures();
    // The open section. Sender Emails can open Sending Domains, on a domain
    // it just added (domainFocus).
    // Stripe sends people back here with ?checkout=..., so open Billing.
    const [active, setActive] = React.useState(() =>
        new URLSearchParams(window.location.search).has("checkout") ? "billing" : "0");
    const [domainFocus, setDomainFocus] = React.useState(null);
    const openSendingDomains = (domain) => {
        setActive("sending-domains");
        setDomainFocus({ domain });
        setTimeout(() => {
            const el = document.getElementById("section-sending-domains");
            if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
    };
    return (
        <Content>

            <AccordionEditors
                activeKey={active}
                onChange={setActive}
                items={[
                    {
                        title: "Settings",
                        component: (<OrganizationSettings />),
                    },
                    {
                        title: "Address",
                        component: (<OrganizationAddress />),

                    },
                    {
                        key: "sending-domains",
                        title: "Sending Domains",
                        component: (<SendingDomains focus={domainFocus} />),
                    },
                    {
                        key: "sender-emails",
                        title: `Sender Emails`,
                        component: (<OrganizationEmails onOpenSendingDomains={openSendingDomains} />),
                    },
                    {
                        title: "Deliverability",
                        component: (<DeliverabilityGuide />),
                    },
                    {
                        title: "Sequence Send Times",
                        component: (<SequenceSendWindow />),
                    },
                    ...(workflows ? [{
                        title: "Pipelines",
                        component: (<PipelineSettings />),
                    }] : []),
                    {
                        title: "Products",
                        component: (<ProductSettings />),
                    },
                    {
                        title: "Custom Fields",
                        component: (<CustomFieldSettings />),
                    },
                    {
                        title: "Webhooks",
                        component: (<WebhookSettings />),
                    },
                    {
                        key: "api-keys",
                        title: "API Keys",
                        component: (<ApiKeys />),
                    },
                    {
                        key: "billing",
                        title: "Billing",
                        component: (<BillingSettings />),
                    },
                    {
                        title: "Administrators",
                        component: (<OrganizationAdmins />),
                    },

                ]}
            />

        </Content>
    );
}
